/**
 * Opérations GraphQL qui créent une charge, une commande, un enregistrement de
 * carte ou un abonnement : elles ne doivent JAMAIS être rejouées automatiquement
 * par le RetryLink. Un rejeu après une réponse perdue (coupure réseau / 5xx
 * survenant APRÈS une capture réussie côté serveur) provoque un double débit ou
 * une double commande. Cf. incidents OUAKIL / CLERJAUD (07/2026).
 *
 * Historique du bug : le garde-fou d'origine testait `startsWith('payline')` en
 * minuscule alors que les opérations réelles sont en PascalCase
 * (`PaylineCaptureSubscriber`, ...). `'PaylineCaptureSubscriber'.startsWith('payline')`
 * vaut `false` -> l'exclusion ne se déclenchait jamais et TOUTES les captures
 * Payline étaient rejouables. On compare désormais en minuscule et on couvre
 * aussi les mutations de charge/commande non préfixées `Payline`.
 *
 * Volontairement RETRYABLES (non listées) : `BookingConfirmIfCaptured` (récupération
 * idempotente par conception), les annulations (`BookingCancel`, `ActivityCancel`,
 * `CancelEvent`), les verrous de créneau (`BookingLock*`, `BookingReleaseSlot`) et
 * les setters sans débit (`SetMembershipSchedule`, `SetRefillStatus`, ...).
 */

const NEVER_RETRY_OPERATION_NAMES = new Set([
  'createaccountwalletoperation', // recharge compte (débit serveur)
  'createoperation', // AccountWallet / Primaccess createOperation
  'setmembershippayment', // capture/enregistrement cotisation
  'setentry', // inscription event/tournament (capture wallet possible)
  'activitybook', // réservation activité (capture wallet possible)
  'bookingbook', // création de la commande/créneau (double commande sur rejeu)
  'bookingconfirm', // confirmation + finalisation paiement
  'confirmsubscription', // mise en place des prélèvements récurrents
  'subscribemembership', // création d'abonnement
]);

/**
 * @param {string|undefined} operationName - `operation.operationName` d'Apollo.
 * @returns {boolean} true si l'opération ne doit jamais être rejouée.
 */
export const isNonRetryablePaymentOperation = (operationName) => {
  const name = (operationName || '').toLowerCase();
  if (!name) return false;
  // Toutes les mutations Payline* (capture, subscribe, token, widget, after3DS).
  if (name.startsWith('payline')) return true;
  return NEVER_RETRY_OPERATION_NAMES.has(name);
};

export default isNonRetryablePaymentOperation;
